import { makeAutoObservable } from "mobx";
import { availableCatalogsForTranslationLoader } from "src/business/catalog/apiCatalog";
import { CatalogFilters, ZCatalog } from "src/business/catalog/ZCatalog";
import { ZSpecCategoryOption } from "src/business/specification";
import {
  AvailSecSpecsFilter,
  ZAvailableSecSpecRow,
  zAvailableSecSpecRow,
  ZSecSpecRow,
} from "src/business/specification/ZSecSpecRow";
import { getApiUrl } from "src/common/api/getUrl";
import { mdmLoader } from "src/common/mdmLoader";
import { RtStore } from "src/components/ReactiveTable/RtStore";

const availSecSpecLoader = (nodeId: string) =>
  mdmLoader(
    zAvailableSecSpecRow,
    getApiUrl(`/core/hierarchies/${nodeId}/schemas/secondary/available`),
  );

export class SecSpecSelectStore {
  constructor(
    public readonly classId: string,
    public readonly linkType: ZSpecCategoryOption,
    public readonly prohibitedNames: Set<string>,
  ) {
    this.specsStore = new RtStore({
      rowKey: "id",
      loader: availSecSpecLoader(classId),
      selectionType: "radio",
      rowSelectionDisabled: (row) => prohibitedNames.has(row.name),
      defaultRequest: { pageSize: 20 },
    });
    makeAutoObservable(this);
  }

  get selectedSpec(): ZAvailableSecSpecRow | undefined {
    const list = this.specsStore.selectedRows;
    return list[0];
  }

  getResult(): ZSecSpecRow | undefined {
    const row = this.specsStore.selectedRows[0];
    return row
      ? {
          ...row,
          linkType: this.linkType,
          catalogs: this.catalogsStore?.selectedRows,
        }
      : undefined;
  }

  specsStore: RtStore<ZAvailableSecSpecRow, AvailSecSpecsFilter>;

  catalogsStore: RtStore<ZCatalog, CatalogFilters> | null = null;

  setCatalogsStore(secondSchemaId: string) {
    this.catalogsStore = new RtStore({
      rowKey: "id",
      loader: availableCatalogsForTranslationLoader(
        this.classId,
        secondSchemaId,
      ),
      selectionType: "checkbox",
      defaultRequest: { pageSize: 20 },
    });
  }

  get canApply(): boolean {
    const { selectedSpec } = this;
    return !!selectedSpec;
  }
}
